import React from "react";
import { Box, Typography } from "@mui/material";
import { QuizStyledCard } from "../../shared/QuizStyledCard";
import { COLORS } from "../constants";
import type { CustomerData, AllSubsIssues, SubscriptionData, AddressGroup } from "../types";

interface Props {
  customer: CustomerData;
  addressGroups: AddressGroup[];
  subscriptions: SubscriptionData[];
  allSubsIssues: AllSubsIssues;
}

function StatBox({ value, label, bgcolor, color }: { value: number; label: string; bgcolor: string; color: string }) {
  return (
    <Box sx={{ textAlign: "center", px: 2, py: 1, bgcolor, borderRadius: "8px" }}>
      <Typography sx={{ fontWeight: 800, fontSize: 20, color }}>{value}</Typography>
      <Typography sx={{ fontSize: 11, color: COLORS.textMuted }}>{label}</Typography>
    </Box>
  );
}

export function CustomerHeader({ customer, addressGroups, subscriptions, allSubsIssues }: Props) {
  return (
    <QuizStyledCard variant="white">
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 2 }}>
        <Box>
          <Typography sx={{ fontWeight: 800, color: COLORS.brownDeep, fontSize: 20, mb: 0.5 }}>
            {customer.first_name && customer.last_name
              ? `${customer.first_name} ${customer.last_name}`
              : "Customer"}
          </Typography>
          <Typography sx={{ fontSize: 14, color: COLORS.brown }}>{customer.email}</Typography>
          <Typography sx={{ fontSize: 12, color: COLORS.textLight, mt: 0.5 }}>
            Recharge ID: {customer.id}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <StatBox value={addressGroups.length} label="Addresses" bgcolor={COLORS.cream} color={COLORS.brown} />
          <StatBox value={subscriptions.length} label="Subscriptions" bgcolor={COLORS.cream} color={COLORS.brown} />
          <StatBox
            value={subscriptions.filter(s => s.status?.toLowerCase() === "active").length}
            label="Active"
            bgcolor={COLORS.greenLight}
            color={COLORS.green}
          />
          {allSubsIssues.hasAnyIssues && (
            <StatBox value={allSubsIssues.subsWithIssues.length} label="Issues" bgcolor={COLORS.redLight} color={COLORS.red} />
          )}
        </Box>
      </Box>
    </QuizStyledCard>
  );
}
